import AppWrapper from 'AppWrapper';
import { apiClient } from 'api';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import { HelmetProvider } from 'react-helmet-async'; // ← ajouter

import { ChainlitContext } from '@chainlit/react-client';
import './index.css';
import { i18nSetupLocalization } from './i18n';
import { installMarketFetch } from './lib/market';

i18nSetupLocalization();
// Marché juridique (fr / eu / us) transmis au backend sur chaque appel /api/
installMarketFetch();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>                              {/* ← wrapper */}
      <ChainlitContext.Provider value={apiClient}>
        <RecoilRoot>
          <AppWrapper />
        </RecoilRoot>
      </ChainlitContext.Provider>
    </HelmetProvider>
  </React.StrictMode>
);